<!--begin::Body-->
<div class="d-flex flex-column flex-center mt-30 mt-lg-0 height-100 password-container">
  <!--begin::Signin-->
  <div class="login-form login-signin">
    <div class="text-center mb-10">
      <h3 class="font-size-h1">Cambiar contraseña</h3>
      <p class="text-muted font-weight-semi-bold">Ingresa una nueva contraseña</p>
    </div>
    <p>La contraseña tendrá una vigencia de 45 días (30 días para cuentas administrativas), después de este tiempo tendrá que renovarla, debe tener en cuenta que su contraseña no debe ser común, ni debe ser similar a su correo electrónico y debe contener al menos una letra minúscula, una letra mayúscula, un número, un carácter especial y debe ser de al menos 8 caracteres.</p>
    <br-alert *ngIf="showAlert"></br-alert>

    <form class="form" [formGroup]="forgotPasswordForm" autocomplete="off">
      <div class="form-group">
        <mat-form-field class="mb-5">
          <mat-label>Nueva contraseña</mat-label>
          <input matInput [type]="hide1 ? 'password' : 'text'" formControlName="password" autocomplete="off" />
          <mat-icon matSuffix (click)="hide1 = !hide1">{{ hide1 ? "visibility_off" : "visibility" }}</mat-icon>
          <mat-error *ngIf="isControlHasError('password', 'required')">
            <strong>Campo requerido</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('password', 'pattern')">
            <strong>La contraseña debe contener al menos una letra minúscula, una letra mayúscula, un número, un carácter especial y debe ser de al menos 8 caracteres</strong>
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Repetir nueva contraseña</mat-label>
          <input matInput [type]="hide2 ? 'password' : 'text'" formControlName="confirmPassword" autocomplete="off" />
          <mat-icon matSuffix (click)="hide2 = !hide2">{{ hide2 ? "visibility_off" : "visibility" }}</mat-icon>
          <mat-error *ngIf="isControlHasError('confirmPassword', 'required')">
            <strong>Campo requerido</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('password', 'pattern')">
            <strong>La contraseña debe contener al menos una letra minúscula, una letra mayúscula, un número, un carácter especial y debe ser de al menos 8 caracteres</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <!--begin::Action-->
      <div class="fform-group d-flex flex-wrap flex-center">
        <button (click)="submit(forgotPasswordForm)" id="kt_login_forgot_submit" class="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4" [ngClass]="{ 'spinner spinner-right spinner-md spinner-light': loading }">Cambiar</button>

        <a routerLink="/auth/login" id="kt_login_signup_cancel" class="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4">Volver</a>
      </div>
      <!--end::Action-->
    </form>
  </div>
  <div class="company-info">
    <div class="mb-5 d-flex justify-content-center">
      <a href="https://twitter.com/AsegurateColombia" target="_blank">
        <img src="../../../../assets/media/logos/twitter.png" alt="twitter" />
      </a>
      <a href="https://www.facebook.com/Aseguratecolombia/" target="_blank">
        <img src="../../../../assets/media/logos/facebook.png" alt="facebook" style="margin-left: 7px" />
      </a>
      <a href="https://linkedin.com/company/Asegurate-s-a-s/" target="_blank">
        <img src="../../../../assets/media/logos/linkedin.png" alt="linkedin" style="margin-left: 7px" />
      </a>
    </div>
    <p class="text-muted font-weight-bold text-justify">Teléfono: (+57 1) 255 9532 | Celular: (+57) 318 706 8636 | Dirección: Calle 71A # 17 – 35 Of. 303 Bogotá - Colombia | contacto@aseguratelimitada.com | <a href="http://www.aseguratelimitada.com/" target="_blank">www.aseguratelimitada.com</a></p>
  </div>
</div>
